<template>
  <input
      type="text"
      :value="value"
      @input="onInput"
      @change="onChange"
      @blur="onBlur"
      ref="datePicker"
      class="form-control"
      v-bind="{...$props, ...inputAttributes}"
  />
</template>

<script>
import moment from 'moment';

export default {
  props: {
    modelValue: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String,
    },
    placeholder: {
      type: String
    },
    value: {}
  },
  computed: {
    inputAttributes() {
      return {...this.$attrs, ...{class: this.$attrs.class !== typeof 'undefined' ? this.$attrs.class : ''}}
    }
  },
  mounted() {
    const _this = this;
    $(this.$refs.datePicker).datepicker({
      pick(event) {
        _this.$emit('input', moment(event.date).format('l'));
      }
    });
  },
  methods: {
    onInput(event) {
      console.log(1)
      this.$emit('input', event.target.value);
    },
    onChange(event) {
      console.log(2)
      this.$emit('change', event.target.value);
    },
    onBlur(event) {
      this.$emit('blur', event.target.value)
    },
  }
}
</script>
